<template>
  <div class="main">
    <div style="padding-bottom: 15px; text-align: center; width: 800px; display: none;">
        <span style="font-size: 25px">
          {{formTitle}}
        </span>
    </div>
    <div class="main2">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-row>
        	<el-col :span="12">
        		<el-form-item label="标题" prop="标题" size="mini">
        		  <el-input v-model="form.标题" ref="标题"></el-input>
        			
        		</el-form-item>
        	</el-col>
					<el-col :span="3">
						<el-form-item label="启用" prop="启用" size="mini" class="demo">
						  <el-switch
						    v-model="form.启用"
								active-value="1"
								inactive-value="0"
						    active-color="#13ce66"
						    inactive-color="#cccccc">
						  </el-switch>
						</el-form-item>
						
					</el-col>
        	<el-col :span="3">
        		<el-form-item label="带视频" prop="带视频" size="mini" class="demo">
        		  <el-switch
        		    v-model="form.带视频"
        				active-value="1"
        				inactive-value="0"
        		    active-color="#13ce66"
        		    inactive-color="#cccccc">
        		  </el-switch>
        		</el-form-item>
        	</el-col>
        	<el-col :span="6">
						
        		<el-button type="primary" size="mini" @click="openDialog($event)" style="margin-left: 10px;">锚点管理</el-button>
        	</el-col>
        	
        </el-row>
        <el-row>
					<el-col :span="12">
						<el-form-item label="备注" prop="备注" size="mini">
						  <el-input v-model="form.备注" ref="备注"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="编辑人备注" prop="编辑人备注" size="mini">
						  <el-input v-model="form.编辑人备注" ref="编辑人备注"></el-input>
						</el-form-item>
					</el-col>
					
				</el-row>
        
        <el-form-item label="内容" prop="内容" style="text-align: left;" class="demo">
          <!-- <vue-html5-editor :content="form.内容" @change="updateData" :height="500" :auto-height="false" :show-module-name="false"></vue-html5-editor> -->
					<TinymceEditorVue v-model="form.内容" :anchorList="anchorList" :toolbar="toolbar" :key="UUID"></TinymceEditorVue>
        </el-form-item>
        
				<el-row>
          <div style="text-align: center;">
          	<el-button ref="sendButton" type="primary" size="mini" @click="submitForm('form')" >{{sendButtonValue}}</el-button>
          	<el-button ref="sendButton2" type="warning" size="mini" @click="close('form')">取消</el-button>
          	
          </div>
        </el-row>
      </el-form>
      </div>
			
  </div>
</template>

<script>
  import * as util from "@/utils/util.js"
	import TinymceEditorVue from "../components/TinymceEditor.vue";
	
	export default {
    data() {
      return {
        form: {
          AutoID: '0',
          标题: '',
          内容: '',
					MainID: '',
					AppID: '',
					备注: '',
					编辑人备注: '',
					带视频: '0',
					启用: '0',
					
        },
				OldValue:"",
        rules: {
          标题: [
            {required: true, message: '请输入帮助标题', trigger: 'blur'}
          ],
					
        },
        sendButtonValue: '保存',
				formTitle: '添加标题',
				type:'',
				id:'0',
				loaded: false,
				anchorList: [],
				toolbar: 'undo redo | fontselect fontsizeselect | formatselect | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | lineheight | bullist numlist outdent indent | link hr lists image media table | code removeformat fullscreen',
				UUID: '',
      }
    },
    methods: {
      submitForm(formName) {
				//console.log(this.labelList);
				//return;
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            //console.log(JSON.stringify(this.form));
            //alert('submit!');
						
						var url="/Handler/WenDang.ashx?mode=new";
						this.$ajax.post(url,this.form).then((response)=>{
						  //console.log(response.data);
						
						  let value=response.data;
						
						  let errorCode=value.errorCode;
						
						  if(errorCode=="0")
						  {
						    this.$message({
						      type: 'success',
						      message: '保存成功:'
						    });
						    
						    this.$store.dispatch('worktabRemoveNoBack', this.$route.name + '-' + this.$route.params.type);
						    
						    this.$router.push({path: '/webdanglist'});
						  }
						  else
						  {
						    let desc=value.desc;
						    this.$alert('保存失败：' +　desc, '系统提示', {
						      confirmButtonText: '确定',
						      callback: action => {
						    
						      }
						    });
						  }
						
						},function(err){
						  console.log(err);
						});

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      close(){
      	this.$store.dispatch('worktabRemoveNoBack', this.$route.name + '-' + this.$route.params.type);
      	
      	this.$router.push({path: '/webdanglist'});
      },
      updateData(e){
        //console.log('e:',e);
        this.form.内容 = e;
      
      }
    },
		created(){
			let findTab=this.$store.state.worktab.list.find(item=>item.name=='WenDangNew-new');
			//console.log('findTab', findTab);
			
			if(findTab){
				this.$route.meta.keepAlive = true;
			}
		},
    mounted(){
			//console.log('new mounted', this.$route.params);
			
			this.UUID=util.CreateUUID();
			
			this.form.MainID=this.$route.params.mlid;
			this.form.AppID=this.$route.params.appid;
			this.form.AutoID= '0';
			this.form.标题= '';
			this.form.内容= '';
			this.form.备注= '';
			this.form.编辑人备注= '';
			this.form.启用= '0';
			this.form.带视频= '0';
			
			// this.anchorList.push({text: '锚点1', value: 'anchor1'});
			// this.anchorList.push({text: '锚点2', value: 'anchor2'});
			// this.anchorList.push({text: '锚点3', value: 'anchor3'});
			// this.anchorList.push({text: '锚点4', value: 'anchor4'});
			
    },
		activated() {
			//console.log('new activated', this.$route.params);
			
			this.UUID=util.CreateUUID();
			
			this.form.MainID=this.$route.params.mlid;
			this.form.AppID=this.$route.params.appid;
			
		},
		components: { TinymceEditorVue },
		
  }
</script>

<style lang="scss" scoped="scoped">
.sendButton {
	padding-left: 10px;
	padding-right: 10px;
	width: 80px;
}
.main2{
	padding: 10px;
	// width: 800px;
	text-align: left;
}

</style>
<style>
  .demo {
    text-align: left;
  }
  .demo .el-switch__label {
    position: absolute;
    display: none;
    color: #fff;
  }
  /*打开时文字位置设置*/
  .demo .el-switch__label--right {
    z-index: 1;
    right: -8px;
  }
   /*关闭时文字位置设置*/
  .demo .el-switch__label--left {
    z-index: 1;
    left: 25px;

  }
  /*显示文字*/
  .demo .el-switch__label.is-active {
    display: block;
    color: #000000;
  }
  .demo .el-switch .el-switch__core,
  .demo .el-switch .el-switch__label {
    width: 50px !important;
  }
	/* 假设编辑器内容渲染在 class 为 editor-content 的容器中 */
	.vue-html5-editor img {
	  max-width: 100%; /* 确保图片不超过容器宽度 */
	  height: auto;    /* 保持宽高比 */
	  display: block;  /* 可选，消除底部空隙 */
	}
</style>